<p-dropdown #myDropdown [options]="options" [(ngModel)]="value" optionLabel="name" optionValue="value" [filter]="true"
    filterBy="name" [autoDisplayFirst]="false" [autoOptionFocus]="false" (onChange)="onValueChange($event)" optionDisabled="inactive"
    appendTo="body">
</p-dropdown>